import React, { FC, Suspense } from 'react';

import { usePageTracking } from '#hooks/router/usePageTracking';

import { ZendeskLayout } from '#/containers/router/components/ZendeskLayout';
import { ZendeskRouter } from '#/containers/router/ZendeskRouter';
import { useAuth } from '#/contexts/AuthProvider';
import { useRouter } from '#/hooks';
import { LoadingPage } from '#/pages/Loading.page';
import { LeftNavigationTemplate } from '#/templates/LeftNavigationTemplate';

import { ErrorBoundary } from '../errors/ErrorBoundary';
import { AnonymousRoutes } from './AnonymousRoutes';
import { PrivateRoutes } from './PrivateRoutes';
import { PublicRoutes } from './PublicRoutes';

export const Router: FC = () => {
  const { isLogged } = useAuth();
  const { isPublicRoute, isZendeskExtensionConsumer } = useRouter();

  usePageTracking();

  // TODO Create reducer for User like UserHelper in backend. Tell don't ask.
  // TODO Create Owner Routes separately.
  if (isPublicRoute()) {
    return (
      <ErrorBoundary>
        <Suspense fallback={<LoadingPage />}>
          <PublicRoutes />
        </Suspense>
      </ErrorBoundary>
    );
  }

  if (isLogged() && isZendeskExtensionConsumer()) {
    return (
      <ErrorBoundary>
        <Suspense fallback={<LoadingPage />}>
          <ZendeskLayout>
            <ZendeskRouter />
          </ZendeskLayout>
        </Suspense>
      </ErrorBoundary>
    );
  }

  if (isLogged()) {
    return (
      <ErrorBoundary>
        <Suspense fallback={<LoadingPage />}>
          <LeftNavigationTemplate>
            <PrivateRoutes />
          </LeftNavigationTemplate>
        </Suspense>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary>
      <Suspense fallback={<LoadingPage />}>
        <AnonymousRoutes />
      </Suspense>
    </ErrorBoundary>
  );
};
